import cn from 'classnames';

import { useIsMobile } from '@sravni/react-utils';

import { AdvantagesBlock } from './AdvantagesBlock';
import { FAQBlock } from './FAQBlock';
import { Footer } from './Footer';
import { HeadBlock } from './HeadBlock';
import { Header } from './Header';
import { Layout } from './Layout';
import { OffersBlock } from './OffersBlock';
import { StatsBlock } from './StatsBlock';
import { StepsBlock } from './StepsBlock';
import styles from './styles.module.scss';

export const Landing = () => {
  const isMobile = useIsMobile();

  return (
    <div className={cn(styles['landing-wrapper'], { [styles.mobile]: isMobile })}>
      <Layout>
        <Header />
        <HeadBlock />
        <StatsBlock />
        <StepsBlock />
        <OffersBlock />
        <AdvantagesBlock />
        <FAQBlock />
      </Layout>
      <Footer />
    </div>
  );
};
